<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <div class="form-title tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-4 lg:tw-mt-12">
                <h2>QUER CONHECER TODAS<br>AS VANTAGENS?</h2>
                <p class="tw-pt-1 tw-pb-3">Saiba mais sem compromisso</p>
            </div>
            <fieldset v-if="formStep == 1" class="tw-pt-10 tw-px-3 tw-pb-3 md:tw-px-12 md:tw-pb-5">
                <validation-provider>
                    <div>
                        <h3>Já é cliente Multicare?</h3>
                        <div class="tw-flex tw-text-center tw-items-center tw-justify-evenly mb-2">
                            <div class="form-check">
                                <label class="label-client">
                                    <input type="radio"
                                        v-model="isClient"
                                        value="1"
                                    >
                                    <div class="checkmark"></div>
                                    <span class="tw-pl-3">
                                        Sim
                                    </span>
                                </label>
                            </div>
                            <div class="form-check">
                                <label class="label-client">
                                    <input type="radio"
                                        v-model="isClient"
                                        value="0"
                                    >
                                    <div class="checkmark"></div>
                                    <span class="tw-pl-3">
                                        Não
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-name" :class="classes">
                        <input type="text"
                            placeholder=" "
                            v-model="name"
                        >
                        <label>
                            Qual o seu Nome e Apelido
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required|phone:pt" v-slot="{ classes }">
                    <div class="input-group input-group-phone" :class="classes">
                        <input type="tel"
                            placeholder=" "
                            v-model="phone"
                            v-mask="'#########'"
                        >
                        <label>
                            Telemóvel
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required|nif" v-slot="{ classes }">
                    <div class="input-group input-group-nif" :class="classes">
                        <input type="tel"
                            placeholder=" "
                            v-model="nif"
                        >
                        <label>
                            Nº Contribuinte
                        </label>
                    </div>
                </validation-provider>
                <div class="tw-text-center tw-mt-3 lg:tw-mt-8">
                    <button
                        type="submit"
                        class="tw-relative btn-cta"
                    >
                        PEDIR SIMULAÇÃO
                    </button>
                </div>
            </fieldset>
            <fieldset v-if="formStep == 2" class="tw-pt-10 tw-px-3 tw-pb-3 md:tw-px-12 md:tw-pb-12">
                <validation-provider class="tw-w-full tw-w-block" rules="required|email" v-slot="{ classes }">
                    <div class="input-group input-group-email" :class="classes">
                        <input type="email"
                            placeholder=" "
                            v-model.lazy="email"
                        >
                        <label>
                            O seu Email
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required|zip:pt" v-slot="{ classes }">
                    <div class="input-group input-group-zip" :class="classes">
                        <input type="tel"
                            placeholder=" "
                            v-model="zip"
                            v-mask="'####-###'"
                        >
                        <label>
                            Código Postal
                        </label>
                    </div>
                </validation-provider>
                <div class="tw-mb-2">
                    <p>Porque precisamos dos seus dados?</p>
                    <p>Os dados pessoais por si acima facultados serão tratados para realizar a presente simulação e fazer o acompanhamento comercial subsequente da  mesma. Se nos der o seu consentimento, iremos também usar a sua  informação para envio de comunicações relativas a produtos e serviços da  Companhia que poderão ser do seu interesse. Recordamos-lhe que tem o  direito de retirar o seu consentimento a qualquer momento. Os seus dados  nunca serão utilizados por terceiros ou entidades externas à Fidelidade<br><span class="terms">Saiba aqui como a Fidelidade irá utilizar os seus dados pessoais.</span></p>
                </div>
                <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                    <div class="mb-2">
                        <div class="form-check p-0">
                            <label class="form-check-label" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                <span class="checkmark"></span>
                                <span>Autorizo a Multicare Fidelidade  a utilizar os meus dados para ser contactado segundo a sua <a href="https://www.fidelidade.pt/PT/protecao-dados/Documents/Politica_de_Privacidade_e_Protecao_de_Dados_Pessoais%E2%80%93FIDELIDADE.pdf" data-target="#terms" target="_blank"><u>política de privacidade</u></a>.</span>
                            </label>
                        </div>
                    </div>
                </validation-provider>
                <div class="tw-text-center tw-mt-4">
                    <button
                        type="submit"
                        class="btn-cta"
                        :disabled="formLoading"
                    >
                        ENVIAR
                    </button>
                </div>
            </fieldset>
            <div class="step-indicators tw-flex tw-items-center tw-justify-center tw-gap-1 tw-pb-10 lg:tw-pb-5 lg:tw-mb-16" v-show="formStep <= 2">
                <span :class="{'active' : formStep >= 1}"></span>
                <span :class="{'active' : formStep >= 2}"></span>
            </div>
        </form>
    </validation-observer>
</template>

<script>
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';
import '@/validations/nif';
import '@/validations/zip';

export default {
    name: 'FormComponent',
    data() {
        return {
            isClient: '',
            name: '',
            phone: '',
            nif: '',
            email: '',
            zip: '',

            formStep: 1,
            formLoading: false,
            usedClasses: ['.has-error'],
        };
    },
    methods: {
        formSubmit() {
            if (this.formStep < 2) {
                this.formStep += 1;
                this.$refs.formHandler.reset();
                return;
            }
            this.formLoading = true;

            let cmpInfo = {
                vendor:{
                    consents: [],
                },
                tcString: '',
            };

            try{
                cmpInfo = __tcfapi('getTCData');
            } catch (e) {
                console.log('No CMP Info');
            }

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                ip: this.$store.state.ip,
                user_agent: window.navigator.userAgent,
                pubid: this.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                ua_device: this.$store.state.ua_device,
                ua_browser: this.$store.state.ua_browser,
                ua_os: this.$store.state.ua_os,
                token: this.$store.state.token,

                isClient: this.isClient,
                name: this.name,
                phone: this.phone,
                nif: this.nif,
                email: this.email,
                zip: this.zip,

                consent: cmpInfo.vendor.consents.hasOwnProperty('702'),
                tcString: cmpInfo.tcString,
                mclic: process.env.VUE_APP_MCLIC,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    if (error.response.status == '302') {
                        this.$store.state.formError = true;
                    }
                    this.formLoading = false;
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';

form {
    width: auto;
    height: auto;
    background-color: #fff;
    @screen lg {
        margin-left: auto;
        max-width: 400px;
        border-radius: 40px;
    }
    .form-title {
        background-color: $gray;
        @screen lg {
            border-top-left-radius: 40px;
            border-top-right-radius: 40px;
        }
        &::before {
            position: absolute;
            top: 21%;
            left: 49%;
            width: 201px;
            height: 60px;
            background-image: url(~@/assets/img/icons/form-before.svg);
            background-position: center center;
            background-repeat: no-repeat;
            content: '';
            transform: translate(-50%, -50%);
            @screen lg {
                top: 23%;
                left: 67%;
            }
        }

        h2 {
            color: #fff;
            font-weight: 900;
            font-size: 20px;
            line-height: 26px;
        }

        p {
            z-index: 2;
            color: #fff;
            font-size: 17px;
            line-height: 30px;
        }
    }

    h3 {
        color: $gray;
        text-align: center;
        font-size: 20px;
        font-family: 'Lato';
        line-height: 30px;
    }

    .step-indicators {
        span {
            display: block;
            margin-right: 3px;
            margin-left: 3px;
            width: 14px;
            height: 14px;
            border: 1px solid $gray;
            border-radius: 100%;
            background: transparent;
            transition: opacity .2s ease-in-out;

            &.active {
                background: $gray;
            }
        }
    }

    p {
        color: #797d82;
        font-size: 10px;
        font-family: 'Lato';
        line-height: 12px;
    }

    span {
        &.terms {
            color: #f00;
        }
    }
}

</style>
